import {
  Button,
  IconButton,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  Theme,
} from '@freighthub/silhouette-core'
import { FC, ReactElement } from 'react'

export type AutocompleteResult = {
  label: string
  value: string
  data?: AutocompleteData
}

const useStyles = makeStyles<Theme>((theme) => ({
  btn: {
    color: theme.palette.primary.main,
    fontSize: theme.typography.body1.fontSize,
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
  },
  icon: {
    marginRight: theme.spacing(1),
  },
}))

export type AutocompleteData = {
  _id?: 'footer' | 'label'
  icon?: ReactElement
  actionIcon?: ReactElement
  onClickAction?: (selection: AutocompleteResult) => void
  text?: string
  subText?: string
  className?: string
  onClick?: () => void
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- // TODO: Replace any with a suitable type
  entity?: any
}

export const NetworkAutocompleteOption: FC<AutocompleteResult & { data: AutocompleteResult }> = ({
  data,
  label,
  value: _,
}) => {
  if (data?._id === 'footer') {
    return (
      <NetworkAutocompleteFooter onClick={data.onClick} icon={data.icon} text={data.text} className={data.className} />
    )
  }

  return (
    <>
      {data?.icon && <ListItemIcon>{data.icon}</ListItemIcon>}
      <ListItemText primary={label} secondary={data?.subText} />
      {data?.actionIcon && (
        <ListItemSecondaryAction>
          {/* @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message */}
          <IconButton onClick={() => data.onClickAction(data)}>{data.actionIcon}</IconButton>
        </ListItemSecondaryAction>
      )}
    </>
  )
}

const NetworkAutocompleteFooter: FC<Omit<AutocompleteData, '_id'>> = ({ onClick, text, icon }) => {
  const classes = useStyles()
  return (
    <Button fullWidth classes={{ startIcon: classes.icon }} startIcon={icon} onClick={onClick}>
      {text}
    </Button>
  )
}
